const hasEventID = ([event, events], id) =>
  !event ? false : event[0] === id ? true : hasEventID(events, id)

const listeningForEvent = event => {
  return ({ path, props: { payload }, state }) => {
    const events = state.get(`app.events.${event}`)
    if (events && hasEventID(Object.entries(events), payload.id)) {
      const eventData = { ...events[payload.id] }
      state.unset(`app.events.${event}.${payload.id}`)
      return path.true(eventData)
    }
    return path.false()
  }
}

export default listeningForEvent



// WEBPACK FOOTER //
// ./src/modules/Socket/factories/listeningForEvent.js